import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, message } from 'antd';
import App from './App';
import '@annea/ui/styles/design-tokens.css';
import './index.css';

const primaryColor = '#f46524';

message.config({
  duration: 6,
  maxCount: 3,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: primaryColor,
            colorLink: primaryColor,
            colorLinkHover: '#d55520',
            colorInfo: primaryColor,
            borderRadius: 6,
          },
          components: {
            Button: {
              colorPrimary: primaryColor,
              colorPrimaryHover: '#d55520',
              colorPrimaryActive: '#b64518',
              borderRadius: 6,
            },
            Input: {
              activeBorderColor: primaryColor,
              hoverBorderColor: primaryColor,
              borderRadius: 6,
            },
            Card: {
              headerBg: '#fff5f0',
              headerFontSize: 20,
              headerHeight: 64,
            },
          },
        }}
      >
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);
